module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": false,
      "headerStyle": {
        'background-color': _vm.currentIntegration.color.main
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Locals")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('top-area', {
    attrs: {
      "integration": _vm.currentIntegration
    }
  }), _vm._v(" "), _c('state-label', {
    attrs: {
      "integration": _vm.currentIntegration
    },
    on: {
      "close": function($event) {
        return _vm.close()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "px-5 pt-4 pb-4"
  }, [_c('bottom-area', {
    attrs: {
      "isIntegrated": _vm.currentIntegration.integrationStatus == 1
    },
    on: {
      "disableIntegration": function($event) {
        return _vm.disableIntegration()
      },
      "saveIntegration": function($event) {},
      "close": function($event) {
        return _vm.closeModal()
      }
    }
  })], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-52f57fee", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52f57fee"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/integrations/integratePopup/hugLocalsIntegrate.vue
// module id = 3203
// module chunks = 0